import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Box,CircularProgress, Button } from '@mui/material';
import PartyInfoForTableRow from 'components/party/components/PartyInfoForTableRow';

import ErrorMessage from 'core/components/ErrorMessage';
import SuccessMessage from 'core/components/SuccessMessage';
import { submitPartyApprovalAPI } from 'api/OmsOrdermgmtWebServices';
import { updatePartyObj } from 'store/slice/PharmaSlice';

export default function SubmitToApproveAPI() {
    const { partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [apiInProgress, setApiInProgress] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {

    }, []);

    const apiSuccess = (response)=>{
        setApiInProgress(false);
        dispatch(updatePartyObj(response.partyInfo))
        setSuccessMsg("Party '"+partyObj.title+"' is submitted for approval !!!");
    }
    const apiFailure = (apiErrMsg)=>{
        setApiInProgress(false);
        setErrMsg(apiErrMsg);
    }
    const handleApiSubmmission = () =>{
        setErrMsg('')
        setApiInProgress(true);

        submitPartyApprovalAPI({
            partyId:partyObj.id
        }, apiSuccess, apiFailure)
    }
    const getComponent = () =>{
        if (apiInProgress) return <CircularProgress/>
        if (successMsg!=='') return <Grid item align="right"  padding={1}><SuccessMessage message={successMsg} /></Grid>

        return <Grid item lg={4} xs={12} align="right"><Button variant="contained" onClick={()=>handleApiSubmmission()}>Submit to Approve</Button></Grid>
    }

    return (
        <>
            <Grid container direction="column" sx={{justifyContent: "flex-start",alignItems: "flex-start",padding:1}}>
                <Grid item lg={12} sx={{ width: '100%', backgroundColor: 'white',padding:1 }}>
                    <Typography variant="h5">Party Info</Typography>
                </Grid>
                
                <Grid item lg={12} sx={{ width: '100%' }}>
                  <Box lg={12} sx={{ flexGrow: 1 }}>
                      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '60vh', padding:1 }}>
                          <PartyInfoForTableRow partyObj={ partyObj} />
                      </Grid>
                  </Box>
                </Grid>

                <Grid container direction="row" sx={{justifyContent: "flex-end",alignItems: "center", padding:2}}>
                    <Grid item lg={8} xs={8} ><ErrorMessage  message={errMsg}/></Grid>
                    {getComponent()}
                </Grid>
            </Grid>
        </>
    )
}